import React from 'react';

import { useMediaQuery } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';

import Logo from 'public/assets/mainLogo.png';

const NoAccessHeader = ({ children }: any) => {
  const isMedia640px = useMediaQuery('(max-width : 640px)');
  return (
    <div className="h-[100vh]">
      <div className="h-[10vh] flex p-4">
        <div className="flex w-[50%] items-center">
          <div className="flex  items-center">
            <Image src={Logo} alt="" />
            <span
              className={`${isMedia640px ? 'ml-2' : 'ml-4'} leading-3 ${
                isMedia640px ? 'text-[0.75rem]' : 'text-default'
              }  font-xx `}
            >
              Fileverse
            </span>
          </div>
        </div>
        <div
          className={` w-[50%] ${
            isMedia640px ? 'mr-2' : 'mr-4'
          }  flex items-center justify-end`}
        >
          <Link href={'/why-fileverse'} passHref={true}>
            <span className=" font-semibold cursor-pointer">
              Why Fileverse ?
            </span>
          </Link>
        </div>
      </div>
      <div className="flex items-center h-[90vh]">{children}</div>
    </div>
  );
};

export default NoAccessHeader;
